import Loader from "../../common/components/Loader";
import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useOfferFilterSubmit } from "../hooks/useOfferFilterSubmit";
import FilterAccordion from "./FilterAccordion";
import FilterFooter from "./FilterFooter";
import FilterHeader from "./FilterHeader";
import FilterOverlay from "./FilterOverlay";
import FocusedFilterContent from "./FocusedFilterContent";
import React from "react";
function FilterOverlayContent({ focusedFilterId, isInitialLoading, initializationFailed, offersCount, loadingFacets, onClose, onSubmit, onClearAll, onRetry, }) {
    if (focusedFilterId) {
        return (<>
        <FilterHeader onBack={onClose} onClearAll={onClearAll}/>
        <FocusedFilterContent filterId={focusedFilterId}/>
        <FilterFooter offersCount={offersCount} loading={loadingFacets} onSubmit={onSubmit}/>
      </>);
    }
    if (isInitialLoading) {
        return (<div className="flex items-center justify-center flex-1">
        <Loader />
      </div>);
    }
    if (initializationFailed) {
        return (<div className="flex flex-col items-center justify-center flex-1 gap-4 p-6 text-center">
        <p className="text-sm text-gray-600">
          Nie udało się załadować filtrów.
        </p>
        <button className="text-sm font-medium underline" onClick={onRetry}>
          Spróbuj ponownie
        </button>
      </div>);
    }
    return (<>
      <FilterHeader onBack={onClose} onClearAll={onClearAll}/>
      <FilterAccordion />
      <FilterFooter offersCount={offersCount} loading={loadingFacets} onSubmit={onSubmit}/>
    </>);
}
export default function OfferFiltersMobile() {
    const { offersCount, loadingFacets, isInitialLoading, initializationFailed, overlayOpen, focusedFilterId, } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const submitFilters = useOfferFilterSubmit();
    const handleClose = () => dispatch({ type: "close_overlay" });
    return (<FilterOverlay open={overlayOpen} onClose={handleClose}>
      <FilterOverlayContent focusedFilterId={focusedFilterId} isInitialLoading={isInitialLoading} initializationFailed={initializationFailed} offersCount={offersCount} loadingFacets={loadingFacets} onClose={handleClose} onSubmit={submitFilters} onClearAll={() => dispatch({ type: "clear_all" })} onRetry={() => dispatch({ type: "initialize_request" })}/>
    </FilterOverlay>);
}
